(() => {
  'use strict';
  if (window.AldevinHollow) return;
  const app = window.AldevinHollow = {busy:false};
  document.documentElement.classList.add('ah-js');
  const root = () => window.Shopify?.routes?.root || document.body.dataset.ahRoot || '/';
  const cartRoute = suffix => root() + 'cart' + suffix;
  const q = (s, el=document) => el.querySelector(s);
  const qa = (s, el=document) => [...el.querySelectorAll(s)];
  let restoreBusy=[];
  function busy(on) {
    app.busy=on;
    if(on){
      restoreBusy=qa('[data-ah-add] button,[data-ah-add] select,[data-ah-add] input,[data-ah-cart] button,[data-ah-cart] input,[data-ah-cart] select');
      restoreBusy.forEach(el=>{el.dataset.ahWasDisabled=String(el.disabled);el.disabled=true;});
    } else {
      restoreBusy.forEach(el=>{if(el.isConnected){el.disabled=el.dataset.ahWasDisabled==='true';delete el.dataset.ahWasDisabled;}});
      restoreBusy=[];
    }
    qa('[data-ah-add],[data-ah-cart]').forEach(el=>el.setAttribute('aria-busy',String(on)));
  }
  function count(cart){
    if(!Number.isInteger(cart?.item_count)) return;
    qa('[data-ah-count]').forEach(el=>el.textContent=String(cart.item_count));
  }
  function notify(text,error=false){
    const box=q('[data-ah-notice]');if(!box)return;
    q('[data-ah-notice-text]',box).textContent=text;
    box.classList.toggle('ah-error',error);box.hidden=false;
  }
  async function request(url,options={}){
    const controller=new AbortController();const timer=setTimeout(()=>controller.abort(),20000);
    try{
      const response=await fetch(url,{credentials:'same-origin',...options,signal:controller.signal,headers:{Accept:'application/json',...(options.headers||{})}});
      let data;try{data=await response.json();}catch(e){throw new Error('The response could not be confirmed. Review your cart before trying again.');}
      if(!response.ok){
        const msg=typeof data.description==='string'?data.description:typeof data.message==='string'?data.message:'The cart could not be updated. Please review your selection.';
        const error=new Error(msg);error.confirmed=true;throw error;
      }
      return data;
    } finally {clearTimeout(timer);}
  }
  async function getCart(){const cart=await request(cartRoute('.js'),{cache:'no-store'});count(cart);return cart;}
  function cartSection(html,focusIndex){
    if(!html)return false;
    const doc=new DOMParser().parseFromString(html,'text/html');const incoming=q('[data-ah-cart]',doc);const current=q('[data-ah-cart]');
    if(!incoming||!current)return false;
    current.replaceWith(incoming);
    if(Number.isInteger(focusIndex)){
      const inputs=qa('[data-ah-cart] [data-ah-cart-quantity]');
      const target=inputs[Math.min(focusIndex,inputs.length-1)]||q('[data-ah-empty-link]',incoming)||q('h1',incoming);
      if(target){target.focus({preventScroll:true});}
    }
    return true;
  }
  async function refreshCart(){
    const el=q('[data-ah-cart]');if(!el)return;
    const id=el.dataset.ahSection;
    const url=new URL(location.href);url.search='';url.searchParams.set('sections',id);
    const sections=await request(url.href,{cache:'no-store'});
    if(!cartSection(sections[id]))throw new Error('Please refresh your cart to see its latest contents.');
  }
  async function add(form){
    if(app.busy)return;
    const quantity=q('[name="quantity"]',form);if(quantity&&!quantity.checkValidity()){quantity.reportValidity();return;}
    // Build the payload before disabling controls. Never retry a cart mutation.
    const data=new FormData(form);const message=q('[data-ah-form-message]',form);if(message)message.textContent='';
    busy(true);
    let added=false;
    try{
      await request(cartRoute('/add.js'),{method:'POST',body:data});added=true;
      try{await getCart();}catch(e){/* Addition was confirmed; do not repeat it. */}
      notify('Added to your cart.');if(message)message.textContent='Added to your cart.';
    }catch(error){
      const text=error.confirmed?error.message:'We could not confirm the addition. Review your cart before trying again.';
      if(message){message.textContent=text;message.classList.add('ah-error');}
      notify(text,true);
      try{await getCart();}catch(e){/* Read-only reconciliation may also be unavailable. */}
    }finally{busy(false);if(added&&message)message.classList.remove('ah-error');}
  }
  async function change(input,quantity){
    if(app.busy)return;
    if(!Number.isInteger(quantity)||quantity<0){input.reportValidity();return;}
    const cartEl=q('[data-ah-cart]');if(!cartEl)return;
    const id=cartEl.dataset.ahSection;
    const inputs=qa('[data-ah-cart-quantity]',cartEl);const focusIndex=inputs.indexOf(input);
    const key=input.dataset.ahKey;
    const errorBox=q('[data-ah-cart-error]',cartEl);if(errorBox)errorBox.textContent='';
    busy(true);
    try{
      const response=await request(cartRoute('/change.js'),{
        method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({id:key,quantity,sections:[id],sections_url:location.pathname})
      });
      count(response);
      // Server-rendered amounts, discounts, currency and fresh keys are authoritative.
      if(!cartSection(response.sections?.[id],focusIndex))await refreshCart();
      const msg=q('[data-ah-cart-message]');if(msg)msg.textContent=quantity===0?'Item removed.':'Cart updated.';
    }catch(error){
      try{await getCart();await refreshCart();}catch(e){/* No mutation retry. */}
      const el=q('[data-ah-cart-error]');
      if(el)el.textContent=error.confirmed?error.message:'We could not confirm the change. Review your cart or refresh the page before trying again.';
    }finally{busy(false);}
  }
  function gallery(anchor){
    const galleryEl=anchor.closest('[data-ah-gallery]');if(!galleryEl)return;
    const target=q('[data-ah-main-image]',galleryEl);if(!target)return;
    target.src=anchor.href;target.srcset=anchor.dataset.ahSrcset||'';target.alt=anchor.dataset.ahAlt||'';
    qa('[data-ah-thumb]',galleryEl).forEach(el=>el.setAttribute('aria-current',String(el===anchor)));
  }
  function variant(select){
    const option=select.selectedOptions[0];const section=select.closest('[data-ah-product]');if(!option||!section)return;
    q('[data-ah-price]',section).textContent=option.dataset.ahPrice;
    const compare=q('[data-ah-compare]',section);if(compare){compare.textContent=option.dataset.ahCompare||'';compare.hidden=!option.dataset.ahCompare;}
    const submit=q('[type="submit"]',select.form);submit.disabled=option.disabled;submit.textContent=option.disabled?'Unavailable':'Add to cart';
    const imageId=option.dataset.ahImage;const thumb=qa('[data-ah-thumb]',section).find(el=>el.dataset.ahImage===imageId);if(thumb)gallery(thumb);
    const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState(null,'',url);
  }
  const catalogStates=new WeakMap();
  async function initCatalog(el){
    if(catalogStates.has(el))return;
    const state={ready:false,loading:false,loaded:new Set([Number(el.dataset.ahPage||1)]),cards:[]};catalogStates.set(el,state);
    const list=q('[data-ah-cards]',el),status=q('[data-ah-catalog-status]',el),retry=q('[data-ah-catalog-retry]',el);
    const controls=qa('[data-ah-sort]',el);controls.forEach(c=>c.disabled=true);
    async function load(){
      if(state.loading)return;state.loading=true;retry.hidden=true;
      const total=Number(el.dataset.ahPages||1);status.textContent=total>1?'Loading the full collection…':'';
      try{
        for(let page=1;page<=total;page++){
          if(state.loaded.has(page))continue;
          const url=new URL(location.href);url.search='';url.hash='';url.searchParams.set(el.dataset.ahPageParam||'page',page);url.searchParams.set('section_id',el.dataset.ahSection);
          const controller=new AbortController();const timer=setTimeout(()=>controller.abort(),20000);let markup;
          try{const response=await fetch(url.href,{credentials:'same-origin',signal:controller.signal});if(!response.ok)throw new Error('catalog');markup=await response.text();}finally{clearTimeout(timer);}
          const doc=new DOMParser().parseFromString(markup,'text/html');const other=q('[data-ah-cards]',doc);if(!other)throw new Error('catalog');
          const known=new Set(qa('[data-ah-card]',list).map(card=>card.dataset.ahId));
          qa('[data-ah-card]',other).forEach(card=>{if(!known.has(card.dataset.ahId)){list.append(card);known.add(card.dataset.ahId);}});
          state.loaded.add(page);
        }
        state.cards=qa('[data-ah-card]',list);state.ready=true;status.textContent='';controls.forEach(c=>c.disabled=false);
        qa('[data-ah-pagination]',el).forEach(n=>n.hidden=true);apply();reveal(el);
      }catch(error){status.textContent='The full collection could not be loaded. Please try again.';retry.hidden=false;}
      finally{state.loading=false;}
    }
    function apply(){
      if(!state.ready)return;
      const params=new URL(location.href).searchParams;const allowed=['home-kitchen','work-technology','outdoor-tools'];
      const category=allowed.includes(params.get('category'))?params.get('category'):'';
      const sort=['featured','price-ascending','price-descending','title-ascending','created-descending'].includes(params.get('sort_by'))?params.get('sort_by'):'featured';
      q('[data-ah-sort]',el).value=sort;
      qa('[data-ah-category]',el).forEach(a=>a.setAttribute('aria-current',String(a.dataset.ahCategory===category)));
      const cards=[...state.cards].sort((a,b)=>{
        if(sort==='price-ascending')return Number(a.dataset.ahPrice)-Number(b.dataset.ahPrice);
        if(sort==='price-descending')return Number(b.dataset.ahPrice)-Number(a.dataset.ahPrice);
        if(sort==='title-ascending')return a.dataset.ahTitle.localeCompare(b.dataset.ahTitle);
        if(sort==='created-descending')return Number(b.dataset.ahCreated)-Number(a.dataset.ahCreated);
        return Number(a.dataset.ahOrder)-Number(b.dataset.ahOrder);
      });
      let visible=0;cards.forEach(card=>{const tags=JSON.parse(card.dataset.ahTags||'[]');card.hidden=!!category&&!tags.includes('ah-'+category);if(!card.hidden)visible++;list.append(card);});
      q('[data-ah-catalog-count]',el).textContent=`${visible} ${visible===1?'product':'products'}`;
      q('[data-ah-catalog-empty]',el).hidden=visible!==0;
    }
    state.apply=apply;
    el.addEventListener('click',event=>{
      const link=event.target.closest('[data-ah-category]');const reset=event.target.closest('[data-ah-reset]');
      if(link||reset){if(!state.ready){event.preventDefault();return;}event.preventDefault();const url=new URL(location.href);
        if(reset){url.searchParams.delete('category');url.searchParams.delete('sort_by');}
        else if(link.dataset.ahCategory)url.searchParams.set('category',link.dataset.ahCategory);else url.searchParams.delete('category');
        url.searchParams.delete(el.dataset.ahPageParam||'page');history.pushState(null,'',url);apply();
      }
    });
    q('[data-ah-sort]',el).addEventListener('change',event=>{if(!state.ready)return;const url=new URL(location.href);url.searchParams.set('sort_by',event.target.value);url.searchParams.delete(el.dataset.ahPageParam||'page');history.pushState(null,'',url);apply();});
    retry.addEventListener('click',load);await load();
  }
  let observer;
  function reveal(scope=document){
    if(!('IntersectionObserver'in window)||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    if(!observer)observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('ah-visible');observer.unobserve(entry.target);}}),{threshold:.06});
    qa('.ah-reveal:not([data-ah-observed])',scope).forEach(el=>{el.dataset.ahObserved='true';el.classList.add('ah-observe');observer.observe(el);});
  }
  function validateForm(form){
    let valid=true;
    qa('input:not([type=hidden]),textarea',form).forEach(input=>{
      input.setCustomValidity('');
      if(input.required&&!input.value.trim()){input.setCustomValidity('Please complete this field.');valid=false;}
      if(input.type==='tel'&&input.value.trim()){
        const digits=input.value.replace(/\D/g,'').length;
        if(!/^\+?[\d\s().-]{7,25}$/.test(input.value.trim())||digits<7||digits>15){input.setCustomValidity('Please enter a valid phone number.');valid=false;}
      }
    });
    return form.reportValidity()&&valid;
  }
  document.addEventListener('submit',event=>{
    const form=event.target;
    if(form.matches('[data-ah-add]')){event.preventDefault();if(!app.busy)add(form);}
    if(form.matches('[data-ah-contact]')&&!validateForm(form))event.preventDefault();
    if(form.matches('[data-ah-cart-form]')&&app.busy)event.preventDefault();
  });
  document.addEventListener('input',event=>{if(event.target.closest('[data-ah-contact]'))event.target.setCustomValidity?.('');});
  document.addEventListener('click',event=>{
    const remove=event.target.closest('[data-ah-remove]');
    if(remove){event.preventDefault();if(app.busy)return;const input=q('[data-ah-cart-quantity]',remove.closest('[data-ah-cart-item]'));if(input)change(input,0);return;}
    const step=event.target.closest('[data-ah-step]');
    if(step){event.preventDefault();if(app.busy)return;const input=q('input',step.closest('.ah-quantity'));if(!input)return;
      const value=Number(input.value)+Number(step.dataset.ahStep);const min=Number(input.min||0),max=input.max?Number(input.max):Infinity;
      if(!Number.isInteger(value)||value<min||value>max)return;
      if(input.matches('[data-ah-cart-quantity]'))change(input,value);else input.value=value;return;}
    const thumb=event.target.closest('[data-ah-thumb]');if(thumb){event.preventDefault();gallery(thumb);}
    if(event.target.closest('[data-ah-notice-close]'))q('[data-ah-notice]').hidden=true;
  });
  document.addEventListener('change',event=>{
    const el=event.target;
    if(el.matches('[data-ah-cart-quantity]')){
      const quantity=Number(el.value);
      if(!el.value.trim()||!Number.isInteger(quantity)||quantity<0){el.setCustomValidity('Enter a whole number of zero or more.');el.reportValidity();return;}
      el.setCustomValidity('');change(el,quantity);
    }
    if(el.matches('[data-ah-variant]'))variant(el);
  });
  document.addEventListener('keydown',event=>{if(event.key==='Escape'){qa('.ah-mobile[open]').forEach(el=>{el.open=false;q('summary',el)?.focus();});const notice=q('[data-ah-notice]');if(notice)notice.hidden=true;}});
  document.addEventListener('click',event=>{qa('.ah-mobile[open]').forEach(el=>{if(!el.contains(event.target))el.open=false;});});
  window.addEventListener('popstate',()=>qa('[data-ah-catalog]').forEach(el=>catalogStates.get(el)?.apply()));
  function init(scope=document){reveal(scope);qa('[data-ah-catalog]',scope).forEach(initCatalog);qa('.ah-mobile',scope).forEach(el=>{if(el.dataset.ahReady)return;el.dataset.ahReady='true';el.addEventListener('toggle',()=>q('summary',el).setAttribute('aria-expanded',String(el.open)));});}
  document.addEventListener('shopify:section:load',event=>init(event.target));
  window.addEventListener('pageshow',event=>{if(event.persisted)getCart().then(()=>q('[data-ah-cart]')?refreshCart():null).catch(()=>{});});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
})();
